export const reformatDate = (date) => {
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const dateObject = new Date(date);
  const dayName = days[dateObject.getDay()];
  const day = String(dateObject.getDate()).padStart(2, '0');
  const month = String(dateObject.getMonth() + 1).padStart(2, '0');
  const year = dateObject.getFullYear();

  return `${dayName} ${day}/${month}/${year}`;
};


export const reformatDateOfBirth = (date) => {
  let D = {};

  D.day = new Date(date).getDate();
  D.month = new Date(date).getMonth() +1;
  D.year = new Date(date).getFullYear();

  return `${D.day} / ${D.month} / ${D.year}`;
}

export const reformatDateTime = (date) => {
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  let D = {};
  D.dayInWeek = new Date(date).getDay();

  D.day = new Date(date).getDate();
  D.month = new Date(date).getMonth() +1;
  D.year = new Date(date).getFullYear();
  D.hour = new Date(date).getHours()
  D.minute = new Date(date).getMinutes()
  D.seconds = new Date(date).getSeconds()

  return `${D.day}/${D.month}/${D.year} -> ${D.hour}:${D.minute}`;
};


export const getAgeFromData = (dateString) => {

var today = new Date();
var birthDate = new Date(dateString);
var age = today.getFullYear() - birthDate.getFullYear();
var m = today.getMonth() - birthDate.getMonth();
if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
}
return age
}


